
import React, { useRef, useState } from 'react';
import axios from 'axios';
import hostlink from '../Hostlink/hostlink';
import * as XLSX from 'xlsx';
import {
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from '@react-pdf/renderer';

const Rpt_PurchaseReport = () => {

    const usershopid = localStorage.getItem('MYPCKARTUSER')
        ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id
        : '0';

    const today = new Date();

    const [frmdata, setfrmdata] = useState({
        fromdate: "2024-01-01",
        todate: today.toISOString().split('T')[0],
        deptcode: 0,
        status: 0
    });

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const tableRef = useRef(null);

    const {
        fromdate,
        todate
    } = frmdata;


    // =========================================================
    // INPUT CHANGE
    // =========================================================

    const onChangevalue = (e) => {

        const {
            name,
            value
        } = e.target;

        setfrmdata({
            ...frmdata,
            [name]: value
        });
    };


    // =========================================================
    // LOAD DATA
    // =========================================================

    const loaddata = async () => {

        if (!fromdate || !todate) {
            return;
        }

        if (fromdate > todate) {
            alert('From Date cannot be greater than To Date');
            return;
        }

        setIsLoading(true);

        try {

            const billResponse = await axios.get(
                `${hostlink}/PurchaseMasviewrpt/0/${usershopid}/${fromdate}/${todate}`
            );

            setData(billResponse.data || []);

        } catch (error) {

            console.log('Data Not Found...', error);

            setData([]);

        } finally {

            setIsLoading(false);
        }
    };


    // =========================================================
    // EXCEL
    // =========================================================

    const exportToExcel = () => {

        if (
            !tableRef.current ||
            data.length === 0
        ) {
            return;
        }

        const ws =
            XLSX.utils.table_to_sheet(
                tableRef.current
            );

        const wb =
            XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            'Purchase Report'
        );

        XLSX.writeFile(
            wb,
            'Purchase Report.xlsx'
        );
    };


    // =========================================================
    // DATE FORMAT
    // =========================================================

    const formatDate = (date) => {

        if (!date) {
            return '-';
        }

        return new Date(date)
            .toLocaleDateString(
                'en-GB',
                {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit'
                }
            );
    };


    // =========================================================
    // TOTALS
    // =========================================================

    const totalMtr = data.reduce(
        (total, res) =>
            total + (parseFloat(res.mtr) || 0),
        0
    );


    const totalRoll = data.reduce(
        (total, res) =>
            total + (parseFloat(res.roll) || 0),
        0
    );


    const totalAmount = data.reduce(
        (total, res) =>
            total +
            (
                (parseFloat(res.mtr) || 0) *
                (parseFloat(res.rate) || 0)
            ),
        0
    );


    // =========================================================
    // UNIQUE BILL COUNT
    // =========================================================

    const uniqueBills = [
        ...new Set(
            data
                .map(item => item.billno)
                .filter(Boolean)
        )
    ].length;


    return (

        <div
            className="container-fluid py-3"
            style={{
                minHeight: '100vh',
                background: '#f5f7fb'
            }}
        >

            {/* =================================================
                HEADER
            ================================================= */}

            <div className="row align-items-center mb-3">

                <div className="col-md-8">

                    <div className="d-flex align-items-center">

                        <div
                            className="d-flex align-items-center justify-content-center me-3"
                            style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '15px',
                                background:
                                    'linear-gradient(135deg,#0d6efd,#4f8dfd)',
                                color: '#fff',
                                boxShadow:
                                    '0 8px 22px rgba(13,110,253,.25)'
                            }}
                        >

                            <i
                                className="fa-solid fa-book"
                                style={{
                                    fontSize: '21px'
                                }}
                            ></i>

                        </div>


                        <div>

                            <h4 className="fw-bold mb-0">
                                Purchase Report
                            </h4>

                            <div
                                className="text-muted"
                                style={{
                                    fontSize: '13px'
                                }}
                            >
                                Purchase transaction summary
                            </div>

                        </div>

                    </div>

                </div>


                <div className="col-md-4 text-md-end mt-3 mt-md-0">

                    <span
                        className="badge rounded-pill px-3 py-2"
                        style={{
                            background: '#fff',
                            color: '#495057',
                            border: '1px solid #e9ecef',
                            boxShadow:
                                '0 3px 12px rgba(0,0,0,.04)'
                        }}
                    >

                        <i className="fa-regular fa-calendar text-primary me-2"></i>

                        {fromdate} → {todate}

                    </span>

                </div>

            </div>


            {/* =================================================
                FILTER CARD
            ================================================= */}

            <div
                className="card border-0 mb-3"
                style={{
                    borderRadius: '18px',
                    boxShadow:
                        '0 6px 25px rgba(31,45,61,.07)'
                }}
            >

                <div className="card-body p-3 p-md-4">

                    <div className="row g-3 align-items-end">


                        {/* FROM DATE */}

                        <div className="col-xl-3 col-lg-4 col-md-6">

                            <label
                                className="form-label fw-semibold mb-2"
                            >

                                <i className="fa-regular fa-calendar text-primary me-2"></i>

                                From Date

                            </label>

                            <input
                                type="date"
                                id="fromdate"
                                name="fromdate"
                                value={fromdate}
                                max={todate}
                                onChange={onChangevalue}
                                className="form-control"
                                style={{
                                    height: '44px',
                                    borderRadius: '9px'
                                }}
                            />

                        </div>


                        {/* TO DATE */}

                        <div className="col-xl-3 col-lg-4 col-md-6">

                            <label
                                className="form-label fw-semibold mb-2"
                            >

                                <i className="fa-regular fa-calendar-check text-primary me-2"></i>

                                To Date

                            </label>

                            <input
                                type="date"
                                id="todate"
                                name="todate"
                                value={todate}
                                min={fromdate}
                                onChange={onChangevalue}
                                className="form-control"
                                style={{
                                    height: '44px',
                                    borderRadius: '9px'
                                }}
                            />

                        </div>


                        {/* SHOW */}

                        <div className="col-xl-2 col-lg-2 col-md-4">

                            <button
                                type="button"
                                onClick={loaddata}
                                disabled={isLoading}
                                className="btn btn-primary w-100"
                                style={{
                                    height: '44px',
                                    borderRadius: '9px',
                                    boxShadow:
                                        '0 5px 15px rgba(13,110,253,.20)'
                                }}
                            >

                                {isLoading ? (

                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                        ></span>

                                        Loading

                                    </>

                                ) : (

                                    <>
                                        <i className="fa-solid fa-magnifying-glass-chart me-2"></i>
                                        Show
                                    </>

                                )}

                            </button>

                        </div>


                        {/* EXCEL */}

                        <div className="col-xl-2 col-lg-3 col-md-4">

                            <button
                                type="button"
                                onClick={exportToExcel}
                                disabled={data.length === 0}
                                className="btn btn-success w-100"
                                style={{
                                    height: '44px',
                                    borderRadius: '9px'
                                }}
                            >

                                <i className="fa-solid fa-file-excel me-2"></i>

                                Excel

                            </button>

                        </div>


                        {/* PDF */}

                        <div className="col-xl-2 col-lg-3 col-md-4">

                            <PDFDownloadLink
                                document={
                                    <PDFDocument
                                        data={data}
                                        fromdate={fromdate}
                                        todate={todate}
                                    />
                                }
                                fileName="Purchase Report.pdf"
                                className="text-decoration-none"
                            >

                                {({ loading }) => (

                                    <button
                                        type="button"
                                        disabled={
                                            data.length === 0 ||
                                            loading
                                        }
                                        className="btn btn-danger w-100"
                                        style={{
                                            height: '44px',
                                            borderRadius: '9px'
                                        }}
                                    >

                                        <i className="fa-regular fa-file-pdf me-2"></i>

                                        {loading
                                            ? 'Loading'
                                            : 'PDF'}

                                    </button>

                                )}

                            </PDFDownloadLink>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                SUMMARY CARDS
            ================================================= */}

            <div className="row g-3 mb-3">


                {/* BILLS */}

                <div className="col-xl-3 col-md-6">

                    <SummaryCard
                        title="Total Bills"
                        value={uniqueBills}
                        icon="fa-solid fa-file-invoice"
                        background="#eaf2ff"
                        iconColor="#0d6efd"
                    />

                </div>


                {/* RECORDS */}

                <div className="col-xl-3 col-md-6">

                    <SummaryCard
                        title="Total Records"
                        value={data.length}
                        icon="fa-solid fa-list"
                        background="#eeeaff"
                        iconColor="#6f42c1"
                    />

                </div>


                {/* MTR */}

                <div className="col-xl-2 col-md-4">

                    <SummaryCard
                        title="Total Mtr"
                        value={totalMtr.toFixed(2)}
                        icon="fa-solid fa-ruler-horizontal"
                        background="#e8f7ff"
                        iconColor="#087990"
                    />

                </div>


                {/* ROLL */}

                <div className="col-xl-2 col-md-4">

                    <SummaryCard
                        title="Total Roll"
                        value={totalRoll}
                        icon="fa-solid fa-scroll"
                        background="#fff3cd"
                        iconColor="#997404"
                    />

                </div>


                {/* AMOUNT */}

                <div className="col-xl-2 col-md-4">

                    <SummaryCard
                        title="Bill Amount"
                        value={`₹ ${totalAmount.toFixed(2)}`}
                        icon="fa-solid fa-indian-rupee-sign"
                        background="#e8f7ee"
                        iconColor="#198754"
                    />

                </div>

            </div>


            {/* =================================================
                TABLE CARD
            ================================================= */}

            <div
                className="card border-0"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow:
                        '0 6px 25px rgba(31,45,61,.07)'
                }}
            >


                {/* TABLE HEADER */}

                <div
                    className="px-3 px-md-4 py-3 border-bottom d-flex justify-content-between align-items-center"
                    style={{
                        background: '#fff'
                    }}
                >

                    <div>

                        <h6 className="fw-bold mb-0">

                            <i className="fa-solid fa-table text-primary me-2"></i>

                            Purchase Details

                        </h6>

                        <small className="text-muted">
                            Bill-wise purchase transactions
                        </small>

                    </div>


                    {data.length > 0 && (

                        <span
                            className="badge rounded-pill px-3 py-2"
                            style={{
                                background: '#eaf2ff',
                                color: '#0d6efd'
                            }}
                        >

                            {data.length} Records

                        </span>

                    )}

                </div>


                {/* TABLE */}

                <div
                    className="table-responsive"
                    style={{
                        maxHeight: '620px'
                    }}
                >

                    <table
                        className="table table-hover align-middle mb-0"
                        ref={tableRef}
                    >

                        <thead
                            style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 5,
                                background: '#f8f9fa'
                            }}
                        >

                            <tr>

                                <th
                                    className="text-start px-3 py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Bill No
                                </th>

                                <th
                                    className="text-start py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Bill Date
                                </th>

                                <th
                                    className="text-start py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Party
                                </th>

                                <th
                                    className="text-start py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Sort No
                                </th>

                                <th
                                    className="text-end py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Mtr
                                </th>

                                <th
                                    className="text-end py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Rate
                                </th>

                                <th
                                    className="text-end py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Roll
                                </th>

                                <th
                                    className="text-end px-3 py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Bill Amount
                                </th>

                            </tr>

                        </thead>


                        <tbody>

                            {data.length === 0 ? (

                                <tr>

                                    <td
                                        colSpan="8"
                                        className="text-center py-5"
                                    >

                                        <div
                                            className="d-flex flex-column align-items-center"
                                        >

                                            <div
                                                className="d-flex align-items-center justify-content-center mb-3"
                                                style={{
                                                    width: '70px',
                                                    height: '70px',
                                                    borderRadius: '50%',
                                                    background: '#f1f3f5',
                                                    color: '#adb5bd'
                                                }}
                                            >

                                                <i
                                                    className="fa-solid fa-file-invoice"
                                                    style={{
                                                        fontSize: '27px'
                                                    }}
                                                ></i>

                                            </div>


                                            <h6 className="fw-bold mb-1">
                                                No Purchase Data
                                            </h6>


                                            <small className="text-muted">
                                                Select the date range and click Show
                                            </small>

                                        </div>

                                    </td>

                                </tr>

                            ) : (

                                data.map((res, x) => {

                                    const isDuplicate =
                                        x > 0 &&
                                        res.billno ===
                                        data[x - 1].billno;


                                    return (

                                        <tr key={x}>


                                            {/* BILL NO */}

                                            <td
                                                className="text-start px-3"
                                            >

                                                {!isDuplicate && (

                                                    <span
                                                        className="badge rounded-pill"
                                                        style={{
                                                            background: '#eaf2ff',
                                                            color: '#0d6efd',
                                                            padding:
                                                                '7px 11px',
                                                            fontWeight: '600'
                                                        }}
                                                    >

                                                        {res.billno}

                                                    </span>

                                                )}

                                            </td>


                                            {/* DATE */}

                                            <td className="text-start">

                                                {!isDuplicate &&
                                                    formatDate(
                                                        res.billdate
                                                    )}

                                            </td>


                                            {/* PARTY */}

                                            <td
                                                className="text-start fw-semibold"
                                            >

                                                {!isDuplicate &&
                                                    res.accname}

                                            </td>


                                            {/* SORT */}

                                            <td className="text-start">

                                                {res.sortno}

                                            </td>


                                            {/* MTR */}

                                            <td className="text-end">

                                                {res.mtr}

                                            </td>


                                            {/* RATE */}

                                            <td className="text-end">

                                                <span
                                                    className="badge bg-light text-dark border"
                                                >

                                                    ₹ {res.rate}

                                                </span>

                                            </td>


                                            {/* ROLL */}

                                            <td className="text-end">

                                                {res.roll}

                                            </td>


                                            {/* AMOUNT */}

                                            <td
                                                className="text-end px-3"
                                            >

                                                {!isDuplicate && (

                                                    <span
                                                        className="fw-bold"
                                                        style={{
                                                            color: '#198754'
                                                        }}
                                                    >

                                                        ₹ {res.billamt}

                                                    </span>

                                                )}

                                            </td>

                                        </tr>

                                    );

                                })

                            )}


                            {/* TOTAL */}

                            {data.length > 0 && (

                                <tr
                                    style={{
                                        background: '#eef5ff',
                                        position: 'sticky',
                                        bottom: 0
                                    }}
                                >

                                    <td></td>

                                    <td></td>

                                    <td></td>

                                    <td
                                        className="text-end fw-bold"
                                    >
                                        Total :
                                    </td>

                                    <td className="text-end fw-bold">
                                        {totalMtr.toFixed(2)}
                                    </td>

                                    <td></td>

                                    <td className="text-end fw-bold">
                                        {totalRoll}
                                    </td>

                                    <td className="text-end px-3">

                                        <span
                                            className="badge rounded-pill bg-success px-3 py-2"
                                        >

                                            ₹ {totalAmount.toFixed(2)}

                                        </span>

                                    </td>

                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>


                {/* FOOTER */}

                {data.length > 0 && (

                    <div
                        className="px-3 px-md-4 py-3 border-top d-flex justify-content-between align-items-center"
                        style={{
                            background: '#fafbfc'
                        }}
                    >

                        <small className="text-muted">

                            Showing{' '}
                            <strong>
                                {data.length}
                            </strong>{' '}
                            records

                        </small>


                        <div>

                            <span className="text-muted me-2">
                                Total Amount
                            </span>

                            <strong className="text-success">
                                ₹ {totalAmount.toFixed(2)}
                            </strong>

                        </div>

                    </div>

                )}

            </div>

        </div>
    );
};


// =========================================================
// SUMMARY CARD
// =========================================================

const SummaryCard = ({
    title,
    value,
    icon,
    background,
    iconColor
}) => {

    return (

        <div
            className="card border-0 h-100"
            style={{
                borderRadius: '15px',
                boxShadow:
                    '0 5px 20px rgba(0,0,0,.06)'
            }}
        >

            <div className="card-body">

                <div
                    className="d-flex justify-content-between align-items-center"
                >

                    <div>

                        <div className="text-muted small">
                            {title}
                        </div>

                        <h5
                            className="fw-bold mb-0 mt-2"
                            style={{
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {value}
                        </h5>

                    </div>


                    <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                            width: '45px',
                            height: '45px',
                            borderRadius: '12px',
                            background: background,
                            color: iconColor,
                            flexShrink: 0
                        }}
                    >

                        <i className={icon}></i>

                    </div>

                </div>

            </div>

        </div>

    );
};


// =========================================================
// PDF
// =========================================================

const PDFDocument = ({
    data,
    fromdate,
    todate
}) => {

    const formatDate = (date) => {

        if (!date) {
            return '-';
        }

        return new Date(date)
            .toLocaleDateString(
                'en-GB',
                {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit'
                }
            );
    };


    const totalMtr = data.reduce(
        (total, res) =>
            total + (parseFloat(res.mtr) || 0),
        0
    );


    const totalRoll = data.reduce(
        (total, res) =>
            total + (parseFloat(res.roll) || 0),
        0
    );


    const totalAmount = data.reduce(
        (total, res) =>
            total +
            (
                (parseFloat(res.mtr) || 0) *
                (parseFloat(res.rate) || 0)
            ),
        0
    );


    return (

        <Document>

            <Page
                orientation="landscape"
                size="A4"
            >

                <View style={styles.container}>

                    <Text style={styles.title}>
                        Purchase Report
                    </Text>

                    <Text style={styles.subtitle}>
                        From : {fromdate} To : {todate}
                    </Text>


                    <View style={styles.table}>

                        <View style={styles.tableRow}>

                            <Text style={styles.headerCell}>
                                Bill No
                            </Text>

                            <Text style={styles.headerCell}>
                                Bill Date
                            </Text>

                            <Text style={styles.headerCell}>
                                Party
                            </Text>

                            <Text style={styles.headerCell}>
                                Sort No
                            </Text>

                            <Text style={styles.headerCell}>
                                Mtr
                            </Text>

                            <Text style={styles.headerCell}>
                                Rate
                            </Text>

                            <Text style={styles.headerCell}>
                                Roll
                            </Text>

                            <Text style={styles.headerCell}>
                                Bill Amount
                            </Text>

                        </View>


                        {data.map((res, x) => {

                            const isDuplicate =
                                x > 0 &&
                                res.billno ===
                                data[x - 1].billno;


                            return (

                                <View
                                    key={x}
                                    style={styles.tableRow}
                                >

                                    <Text style={styles.cell}>
                                        {!isDuplicate
                                            ? res.billno
                                            : ''}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {!isDuplicate
                                            ? formatDate(
                                                res.billdate
                                            )
                                            : ''}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {!isDuplicate
                                            ? res.accname
                                            : ''}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.sortno}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.mtr}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.rate}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.roll}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {!isDuplicate
                                            ? res.billamt
                                            : ''}
                                    </Text>

                                </View>

                            );

                        })}


                        {/* TOTAL */}

                        <View style={styles.tableRow}>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}>
                                Total :
                            </Text>

                            <Text style={styles.cell}>
                                {totalMtr.toFixed(2)}
                            </Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}>
                                {totalRoll}
                            </Text>

                            <Text style={styles.cell}>
                                {totalAmount.toFixed(2)}
                            </Text>

                        </View>

                    </View>

                </View>

            </Page>

        </Document>
    );
};


// =========================================================
// PDF STYLES
// =========================================================

const styles = StyleSheet.create({

    container: {
        padding: 20
    },

    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 5,
        textAlign: 'center'
    },

    subtitle: {
        fontSize: 9,
        marginBottom: 15,
        textAlign: 'center'
    },

    table: {
        display: 'table',
        width: '100%'
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#cccccc'
    },

    headerCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 6,
        flex: 1,
        textAlign: 'center'
    },

    cell: {
        fontSize: 8,
        padding: 6,
        flex: 1,
        textAlign: 'center'
    }

});


export default Rpt_PurchaseReport;

